import React from 'react';
import Main from './main/Main';
//https://kentcdodds.com/blog/how-to-use-react-context-effectively
//https://stackoverflow.com/questions/53510949/how-to-create-a-global-variable-that-can-be-accessed-in-different-component-in-r
// https://www.geeksforgeeks.org/how-to-pass-data-from-one-component-to-other-component-in-reactjs/

function App() {
  function returnCorrectPage() {
    return (<Main/>);
  }

  return (
    <>
    {returnCorrectPage()}
    </>
  );
}

export default App;

